import JSEncrypt from 'encryptlong'

// rsa加密
export function rsaEndCode(key, value) {
  var encryptor = new JSEncrypt()  // 创建加密对象实例
  //之前ssl生成的公钥，复制的时候要小心不要有空格
  var pubKey = key
  encryptor.setPublicKey(pubKey)//设置公钥
  var rsaPassWord = encryptor.encryptLong(value)  // 对内容进行加密

  return rsaPassWord;
}
// rsa解密
export function rsaDeCode(value) {
  var encryptor = new JSEncrypt()//创建解密对象实例
  //之前ssl生成的秘钥
  var priKey = `MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCzmC/QrVxiMlVa
  WrIHNs+sRgd3KcdFVlgE/bI2QHz7yMSohGKp4apKPuPbaYhqQZH524SVN/SghRRx
  X2Kya6Sk/giZQ3ffQ/hNGd+hmUvc7WYP3IucgtBK21wufuPyyLG89CEnu+2vPk3H
  ondcSBLuEZAijKyPyk+bkjxWHmjVU2RvlDY4KF4R4roq6bdmSHNYKL3JjKKwxmOG
  w+xs7BJXcA2m/bFW56S1N5T2/lOVs9tWJWmoJsmmPDOQxjW0luLqG2Smbtr+VqD2
  gQuSnDRukLLSnNiSLszR7ESPDnUmuX0XeF7k6VX/bKB5UmYzvURi68AhzkNHlxfL
  6/iok5NPAgMBAAECggEAeQIsBZEp1EhR1mWR2uaFm3A8C4Cs8f0xpXtDHuboz8YB
  LAK3b/vLf+dMJETBU8cGkrHkbZ6cR6QjmBhLKij5cOpx5MLe/CKSJXEvi3T89slG
  oZ1avIQv0KBpRjLdaHLtv4FG7bzkc9WpFsBTaGxvxNU0pvLeOqx4YzxvRx+KR2Gd
  ckgDP8j6EhpCSv9hBPodiWldNcgWjwnM3nS+ely/buCJ7XC0xp9Rod3io5Ck7IvL
  8t+byIT6tIc3dg/GHppkn2/MthXIBFUeWWK8yW6VaNisrOfb1G6Vok66AhurvXGj
  4rHkW4CWyTwgNg0QrKibIwZmZJEYSttlwZbQV6FiIQKBgQDmYdQneWV5kbDjcSvf
  Q7Sp+WPSrTcfaCkENVdoWJdljcxRt2iUn/LCVJd4ETJUZ93VLyrN5UxyRzZSkSi4
  i6u2LY7hsrZSeWbGVZTp1gCrd/spK+mn6yjBEcHbAO4Yq6dfvVOLkljYUAQTmsqN
  myi4AM3Q03cIpkGWd9r8/NAs6QKBgQDHkJyIuQ4tkIGtgrcDz3K3KFmVGCcEGDRk
  6rVcNdgRTfVy+Gn6gKV1fAbN8NPd5TDdqNqjUfZS6Po85BIPriOcXCXZ1/XPkjTQ
  xSlFEJ1xecE6unFT5hLGyqgkyym1HbC++w6IyJToKRzry1V/YE26nRQs5zhe10BU
  ZKHEUK07dwKBgAMq0yTbyWZbd2gZFTZTkvdHQ3URBpH6951kMlhv51zxDx8Me3aX
  oFnFmfN/oQaCCw20QU1lWqCzk+6cqkenO+wcQjueHl2R57TQVmTEmWvCEYTmYqb5
  V60X1mdxYtSZ/4oUa0Ke93O53eR7G0/JE008TZgSYC+RQZOVAEC8JQyJAoGAc7EB
  Hj3x2zZgBx+1S48y2L2amVWEINqLXUm30/ofBYElXv5mKeP0h9Rb+X24xXW9y3K9
  NVspqs0HbM9nLRHt8RJ2mwCYrzn6RmFWWISWUZedDpfRZSsHDZmkupfQ2P+aXE0d
  Euz9bk2PR578NLi2tw2jCZkN0+WDlKk2IqIGm2cCgYAHLIGFlBzepMRDDWL0c+UH
  cEY46feJMn7aNYmSG3R59s55qDK5KuPDYKts7k9bzzYFVRglDX8QO/yjru/jVI21
  egWWCAyReeoF4DNrahPFwtYTUBtp3dtzv7NL1jk0lamNnlKSn6VNR9TKF2kIia1D
  QwIFJ2kggmepwmc0RWy/PA==`
  encryptor.setPrivateKey(priKey)//设置秘钥
  var uncrypted = encryptor.decrypt(value)//解密之前拿公钥加密的内容
  return uncrypted;
}

/**
 * 跳转首页
 * @param {路由实例} $router 
 */
export function toEntry($router) {
  $router.push({
    path: '/', query: {
      firstBrandId: localStorage.getItem('firstBrandId'),
      projectIntegralId: localStorage.getItem('projectIntegralId'),
      isPC: localStorage.getItem('isPC')
    }
  });
}

export function getExactTime(time) {
  var date = new Date(time);
  // var date = new Date(time* 1000);
  var year = date.getFullYear()
  var month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var dates = date.getDate()
  var hour = (date.getHours() ? date.getHours() < 10 ? '0' + date.getHours() : date.getHours() : '00')
  var min = (date.getMinutes() ? date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() : '00')
  var second = date.getSeconds() ? date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() : '00';
  return `${year}-${month}-${dates} ${hour}:${min}:${second}`;
}